import { SummaryDocument } from "src/app/common/models/summary-document.model";
import { MediaStatus } from "src/app/common/services/media-status-data.service";
import { deserializeToSpeechSegment, SpeechSegment } from "src/app/modules/speech2text/models/speech-segment.model";

export const speakerGlobalId = "global";

export interface Audio extends SummaryDocument {
  availableLanguages: string[];
  detectedLanguage: string;
  filepath: string;
  id: string;
  status: MediaStatus;
  title: string;
  transcribed: boolean;
  segments: SpeechSegment[];
  dubbings: Record<string, AudioDubbing>;
  translated: boolean;
  uploadDate?: number;
  user: string;
  message?: string;
  thumbnailMetadata?: {
    url?: string;
    presignedUrl?: string;
    jobId?: string;
    status?: "READY" | "GENERATING" | "ERROR";
  };
}

export interface AudioDubbing {
  status: "NOT_STARTED" | "PROCESSING" | "DONE" | "ERROR";
  filepath: string;
  segments: SpeechSegment[];
}

export const deserializeToAudio = (input: Partial<Audio>): Audio => {
  if (!input.id) {
    throw new Error(`Missing id in audio=${JSON.stringify(input)}`);
  }
  const availableLanguages = input.availableLanguages || [];
  const dubbings = input.dubbings || {};
  const detectedLanguage = input.detectedLanguage?.toUpperCase() || "FR";
  const segments = input.segments?.map((segment) => deserializeToSpeechSegment(segment)) ?? [];
  return {
    availableLanguages,
    detectedLanguage,
    filepath: input.filepath || "",
    id: input.id,
    status: input.status || "UPLOADING",
    summary: input.summary || "",
    title: input.title || "",
    transcribed: segments.length > 0,
    segments,
    translated: segments.flatMap((s) => Object.values(s.translatedTexts || {})).length > 0,
    uploadDate: input.uploadDate,
    user: input.user || "",
    message: input.message,
    thumbnailMetadata: input.thumbnailMetadata,
    dubbings,
  };
};
